import { CodeStatus, EmbeddedCodeLike } from '@jms/model';
import { colorsUtilityBackgroundGrayMuted, colorsUtilityBackgroundGrayStrong } from '@workbuddy/ui/styles-js';

export class ItemStatusHelper {
    public static itemStatusColor(item: EmbeddedCodeLike): { background: string, foreground: string } {
        let statusBgColor = colorsUtilityBackgroundGrayMuted;
        let statusFrColor = colorsUtilityBackgroundGrayStrong;

        if (item?.isClaimCode) {
            statusFrColor = "#9A3412";
            statusBgColor = "#FED7AA";
        }
        else {
            switch (item?.status) {
                case CodeStatus.Normal:
                    statusFrColor = "#1F2937";
                    statusBgColor = "#E5E7EB";
                    break;

                case CodeStatus.Variation:
                    statusFrColor = "#065F46";
                    statusBgColor = "#A7F3D0";
                    break;

                case CodeStatus.Cancelled:
                    statusFrColor = "#991B1B";
                    statusBgColor = "#FECACA";
                    break;
            }
        }

        return {
            background: statusBgColor,
            foreground: statusFrColor
        }
    }
}